module.exports = __webpack_public_path__ + "static/media/GEO-2.6df22752.png";